import * as Utils from "./utils";

export function init() {
    const toggles = document.querySelectorAll('.js-toggle');

    if (toggles.length) {    
        toggles.forEach(toggle => {
            toggle.addEventListener('click', () => {
                const toggleTarget = document.querySelector(toggle.dataset.target);

                if (toggle.classList.contains('open')) {                
                    toggle.classList.remove('open');

                    // Reveal the content
                    Utils.slideUp(toggleTarget);
                } else {
                    toggle.classList.add('open');

                    // Reveal the content
                    Utils.slideDown(toggleTarget);
                }
            });
        });
    }
}